module.exports = __webpack_public_path__ + "images/emoji/cherries.38f2e6f737222bf121a1.png";